import { Component } from '@opten/gin-tonic/helpers/compiler';
import gsap from 'gsap';
import { Observer } from 'gsap/Observer';

@Component({ className: 'js-nav-visibility' })
export class NavVisibilityComponent {
	constructor(private element: HTMLElement) {
		gsap.registerPlugin(Observer);
		this.setTopStyle();

		Observer.create({
			target: window,
			type: 'scroll',
			tolerance: 50,
			onUp: () => {
				this.element.classList.remove('is-hidden');
			},
			onDown: () => {
				if (window.scrollY > 100) {
					this.element.classList.remove('is-top');

					this.element.classList.add('is-hidden');
				}
			},
			onChange: () => this.setTopStyle()
		});
	}

	private setTopStyle() {
		if (window.scrollY < 100) {
			this.element.classList.add('is-top');
		}
	}
}
